import React, { useState, useEffect, useContext, useRef } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import { getContentIndex, fetchContentIndex } from 'alpha-js'

import BlogItem from '../contentblocks/BlogItem'
import ListSection from './ListSection'

const styles = theme => ({
  root: {
    display: 'flex',
//    backgroundColor: theme.palette.secondary.light,
    overflow: 'hidden',
  },
  container: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(6),
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  items: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0, 5),
  },
  title: {
    marginBottom: theme.spacing(14),
  },
  number: {
    fontSize: 24,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightMedium,
  },
  image: {
    height: 55,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  curvyLines: {
    pointerEvents: 'none',
    position: 'absolute',
    top: -180,
    opacity: 0.7,
  },
  button: {
    marginTop: theme.spacing(8),
  },
});

const BlogFeed = (props) => {

  const { classes, theme, blogList, fetchBlogList, openLink } = props  
  
  useEffect(() => {
    fetchBlogList()
  }, [])  
  
  let items = []
  if (blogList.lastFetched) {
    items = blogList.data.records
  }  

  const renderItem = (item) => {
    return (
      <BlogItem item={item} onClick={() => openLink('story/' + item.key)}/>
    )
  }

  return (
    <ListSection { ...props } removeNotFullRow={true} items={ items }/>
  )
}

BlogFeed.propTypes = {
  classes: PropTypes.object.isRequired,
}

function categoryKeyFromProps(props) {
  let key = null
  if (props.categoryKey !== undefined)
    key = props.categoryKey
  else if (props.match && props.match.params.categoryKey !== undefined)
    key = props.match.params.categoryKey
  return key
}

const mapStateToProps = (state, ownProps) => {
  let categoryKey = categoryKeyFromProps(ownProps)
  let indexKey = categoryKey ? categoryKey : 'default'

  return { 
    blogList: getContentIndex(state, 'blog', indexKey),
    categoryKey: categoryKey,
    categoryList: getContentIndex(state, 'blog-category', 'default'),
    }
} 

const mapDispatchToProps = (dispatch, ownProps) => {
  let categoryKey = categoryKeyFromProps(ownProps)
  let indexKey = categoryKey ? categoryKey : 'default'

  return {
    fetchBlogList: (refresh=false) => {
      let params = categoryKey ? { category_f: categoryKey } : null
      dispatch(fetchContentIndex('blog', indexKey, params, refresh))
    },
    fetchCategoryList: (refresh=false) => {
      dispatch(fetchContentIndex('blog-category', 'default', null, refresh))
    },
  }
}

export default withStyles(styles, { withTheme: true})(connect(
  mapStateToProps,
  mapDispatchToProps
)(BlogFeed))
